import i18n from 'i18next';
import type {FC} from 'react';
import {BrowserRouter, Navigate, Outlet, Route, Routes, useParams} from 'react-router-dom';
import AuthenticatedLayout from './pages/AuthenticatedLayout';
import CogScreenshotPage from './pages/CogScreenshotPage';
import FieldMapPage from './pages/FieldMapPage';
import FleetMapPage from './pages/FleetMapPage';
import MainMenuPage from './pages/MainMenuPage';
import NotFoundPage from './pages/NotFoundPage';
import TrackMapPage from './pages/TrackMapPage';
import TrackScreenshotPage from './pages/TrackScreenshotPage';

const LangFilter: FC = () => {
  const {lang} = useParams();
  const supportedLanguages = ['en', 'es'];

  if (!lang || !supportedLanguages.includes(lang)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
};

const AppRoutes: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="cogScreenshot" element={<CogScreenshotPage />} />
        <Route path="trackScreenshot" element={<TrackScreenshotPage />} />
        <Route path=":lang" element={<LangFilter />}>
          <Route element={<AuthenticatedLayout />}>
            <Route index element={<MainMenuPage />} />
            <Route path="fieldMap" element={<FieldMapPage />} />
            <Route path="fieldMap/:selectedFieldUuid" element={<FieldMapPage />} />
            <Route path="trackMap" element={<TrackMapPage />} />
            <Route path="fleetMap" element={<FleetMapPage />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to={`/${i18n.resolvedLanguage || 'es'}/`} replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
